import { useEffect, useState } from "react";
import { Ban } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";

export function BlockedList() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/blocks").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  const unblock = async (u) => {
    try { await api.delete(`/users/${u.user_id}/block`); setList((l) => l.filter((x) => x.user_id !== u.user_id)); toast.success(`${u.name} ist nicht mehr blockiert`); } catch (e) { toast.error(formatErr(e)); }
  };
  if (!list) return null;
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100 space-y-3" data-testid="blocked-list">
      <h3 className="font-bold text-lg flex items-center gap-2"><Ban className="w-5 h-5 text-rose-500" /> Blockierte Mitglieder</h3>
      {list.length === 0 ? <p className="text-sm text-slate-500" data-testid="blocked-list-empty">Du hast niemanden blockiert.</p> : (
        <ul className="space-y-2">
          {list.map((u) => (
            <li key={u.user_id} className="flex items-center gap-3" data-testid={`blocked-${u.user_id}`}>
              <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-9 h-9" />
              <UserLink id={u.user_id} className="flex-1 min-w-0 truncate text-sm font-semibold">{u.name}</UserLink>
              <button onClick={() => unblock(u)} data-testid={`unblock-${u.user_id}`} className="px-3 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-xs font-bold text-slate-600">Aufheben</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
